import * as React from "react";
const SvgYetToStart = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 13 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.762 1.82a.637.637 0 0 1-.47-.191.642.642 0 0 1-.19-.472c0-.186.063-.342.19-.468A.642.642 0 0 1 .762.5h6.666c.186 0 .342.064.47.192.127.127.19.285.19.471a.632.632 0 0 1-.19.469.642.642 0 0 1-.47.188H.762Zm0 2.967a.636.636 0 0 1-.47-.192.642.642 0 0 1-.19-.471c0-.187.063-.343.19-.469a.642.642 0 0 1 .47-.188h6.666c.186 0 .342.064.47.191.127.128.19.285.19.472a.632.632 0 0 1-.19.468.642.642 0 0 1-.47.189H.762Zm0 2.976a.654.654 0 0 1-.66-.673c0-.186.063-.342.19-.468a.642.642 0 0 1 .47-.189h3.94c.185 0 .342.064.469.192.127.128.19.285.19.471a.644.644 0 0 1-.19.478.642.642 0 0 1-.47.19H.762Zm9.276 3.24a.527.527 0 0 1-.597.05.531.531 0 0 1-.306-.502V6.769c0-.227.102-.393.306-.497a.543.543 0 0 1 .597.046l2.55 1.887c.154.114.231.267.231.46a.52.52 0 0 1-.23.452l-2.551 1.887Z"
      fill="#7A869A"
    />
  </svg>
);
export default SvgYetToStart;
